// Howyin Streaming Portal — embeds the watch.howyin.com admin (Live TV &
// movies CMS) inside the Howyin admin. The portal keeps its own login; its
// nginx CSP (frame-ancestors) only permits framing from this admin origin.
const StreamingPortal = () => {
  return (
    <div style={{ height: "calc(100vh - 80px)", margin: "-24px -24px 0" }}>
      <iframe
        src="https://watch.howyin.com/login"
        title="Howyin Streaming Portal"
        style={{ width: "100%", height: "100%", border: "none", display: "block" }}
        allow="clipboard-write"
      />
    </div>
  );
};

export default StreamingPortal;
